// extracted by mini-css-extract-plugin
module.exports = {"origin-dest-input":"OriginDestInput_origin-dest-input__14TFv","compare-icon":"OriginDestInput_compare-icon__xfVJB"};